export const emailAuthEnabled =
    String(process.env.REACT_APP_EMAIL_AUTH_ENABLED).toLowerCase() === 'true'
